import { nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';
import { getContactName } from './DataFormatterUtils';

export const getFieldTechContact = (fieldTech) => nullSafeGet('supplierContact', fieldTech);

export const getFieldTechDisplayName = (fieldTech) =>
	getContactName(getFieldTechContact(fieldTech) || {}).trim() ||
	nullSafeGetOrElse('name', fieldTech, '') ||
	nullSafeGetOrElse('email', fieldTech, '');
